import { render, staticRenderFns } from "./patientsPortalMessage.vue?vue&type=template&id=7fed9c9b&"
import script from "./patientsPortalMessage.vue?vue&type=script&lang=js&"
export * from "./patientsPortalMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports